import { Settings } from 'react-slick'
import Australia from '../../assets/images/icons/Austria.svg'
import China from '../../assets/images/icons/China.svg'
import EMEA from '../../assets/images/icons/EMEA.svg'
import France from '../../assets/images/icons/France.svg'
import Germany from '../../assets/images/icons/Germany.svg'
import Japan from '../../assets/images/icons/Japan.svg'
import Korea from '../../assets/images/icons/Korea.svg'
import Mexico from '../../assets/images/icons/Mexico.svg'
import Spain from '../../assets/images/icons/Spain.svg'
import UnitedKingdom from '../../assets/images/icons/UnitedKingdom.svg'
import { SubCategory } from '../types/ContentStack'
import { BOOSTER_TYPE, FORM_TYPE, ROUTES } from './enum'
export const ALL_POSTS: SubCategory = {
    category: '',
    title: 'All Posts',
}

export const MESSAGES = {
    info: {
        resendOtp: 'code_verification_page.code_verification_resent_text',
        noRecords: 'common_elements.no_records',
        inviteSent: 'common_elements.invite_sent',
    },
    error: {
        required: (field: string) => `Please enter ${field}.`,
        invalid: (field: string) => `Please enter valid ${field}.`,
        subscribeEmail: `This is not an email address.`,
        endpointError: 'common_elements.something_wrong_text',
        failedTo: (operation: string, value = '') =>
            `Failed to ${operation} ${value}.`,
        verificationCode:
            'code_verification_page.code_verification_value_error',
        invalidVerificationCode:
            'code_verification_page.code_verification_invalid_error',
        verificationCodeExpired:
            'code_verification_page.code_verification_expired_error',
        inValidBeautyHealthID:
            'onboarding_name_page.onboarding_beauty_health_customer_id_invalid',
        mobileNumberAlreadyInUse:
            'code_verification_page.code_verification_mobile_number_already_in_use',
        emailAlreadyInUse:
            'code_verification_page.code_verification_email_already_in_use',
    },
}

export const SLIDERS_SETTINGS: Settings = {
    centerMode: true,
    infinite: true,
    centerPadding: '120px',
    slidesToShow: 1,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                centerPadding: '0px',
                centerMode: false,
                dots: true,
                autoplay: false,
                lazyLoad: 'progressive',
            },
        },
    ],
}

export const MULTI_SLIDERS_SETTINGS: Settings = {
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                dots: true,
                autoplay: false,
                lazyLoad: 'progressive',
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                dots: true,
                autoplay: false,
                lazyLoad: 'progressive',
            },
        },
    ],
}

export const PARTIAL_SLIDER_SETTINGS: Settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    slidesToShow: 2,
    speed: 500,
    dots: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                autoplay: false,
                lazyLoad: 'progressive',
            },
        },
    ],
}

export const BANNER_SLIDERS_SETTINGS: Settings = {
    infinite: true,
    slidesToShow: 1,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                autoplay: false,
                lazyLoad: 'progressive',
            },
        },
    ],
}

export const TALKWITHSALEOPTIONS = [
    '/talk-with-sales/sales/',
    '/talk-with-sales/rewards/',
    '/talk-with-sales/training/',
]

export const PERSONALIZATIONS = 'PERSONALIZATIONS'

export const EXPRESS = 'express'

export const countrySelectionOptions = [
    {
        key: 'Australia',
        flag: Australia,
        value: 'https://www.hydrafacial.com.au/',
    },
    {
        key: 'China',
        flag: China,
        value: 'https://www.hydrafacial.com.cn/',
    },
    {
        key: 'EMEA',
        flag: EMEA,
        value: 'https://hydrafacialemea.com/',
    },
    {
        key: 'France',
        flag: France,
        value: 'https://hydrafacial.fr/',
    },
    {
        key: 'Germany',
        flag: Germany,
        value: 'https://www.hydrafacial.de/',
    },
    {
        key: 'Japan',
        flag: Japan,
        value: 'https://hydrafacial.co.jp/ ',
    },
    {
        key: 'Korea',
        flag: Korea,
        value: 'https://hydrafacial.kr/',
    },
    {
        key: 'MENA',
        flag: EMEA,
        value: 'https://hydrafacial.ae/',
    },
    {
        key: 'Mexico',
        flag: Mexico,
        value: 'https://hydrafacial.com.mx/',
    },
    {
        key: 'Spain',
        flag: Spain,
        value: 'https://www.hydrafacial.es/',
    },
    {
        key: 'United Kingdom',
        flag: UnitedKingdom,
        value: 'https://hydrafacial.co.uk/',
    },
]

export const fahCountrySelectionOptions = [
    {
        key: 'Australia',
        flag: Australia,
        value: 'https://www.hydrafacial.com.au/find-a-hydrafacialist/',
    },
    {
        key: 'China',
        flag: China,
        value: 'https://www.hydrafacial.com.cn/support',
    },
    {
        key: 'Rest of Europe, Middle East and Africa',
        flag: EMEA,
        value: 'https://hydrafacialemea.com/find-a-provider/',
    },
    {
        key: 'France',
        flag: France,
        value: 'https://hydrafacial.fr/find-a-provider-2/',
    },
    {
        key: 'Germany',
        flag: Germany,
        value: 'https://www.hydrafacial.de/find-a-provider/',
    },
    {
        key: 'Japan',
        flag: Japan,
        value: 'https://hydrafacial.co.jp/find-a-provider',
    },
    {
        key: 'Korea',
        flag: Korea,
        value: 'https://hydrafacial.kr/kr-find-a-provider/',
    },
    {
        key: 'Mexico',
        flag: Mexico,
        value: 'https://hydrafacial.com.mx/encuentra-un-hydrafacialista',
    },
    {
        key: 'Spain',
        flag: Spain,
        value: 'https://www.hydrafacial.es/find-a-provider',
    },
    {
        key: 'United Kingdom',
        flag: UnitedKingdom,
        value: 'https://hydrafacial.co.uk/find-a-provider/',
    },
]

export const TalkWithSaleselectOptions = [
    {
        value: 'Training Program',
        key: 'trainingProgram',
        link: `${ROUTES.TALK_WITH_SALES}${FORM_TYPE.TRAINING}/`,
    },
    {
        value: 'Sales',
        key: 'sales',
        link: `${ROUTES.TALK_WITH_SALES}${FORM_TYPE.SALES}/`,
    },
    {
        value: 'Rewards Program',
        key: 'rewardsProgram',
        link: `${ROUTES.TALK_WITH_SALES}${FORM_TYPE.REWARDS}/`,
    },
]

export const HkxOptions = [
    {
        value: 'Please choose your program',
        key: 'chooseyourprogram',
    },
    {
        value: 'Virtual HKX',
        key: 'virtualhkx',
    },
]

export const VirtualHKXOptions = [
    {
        value: 'October 13',
        key: 'October13',
    },
    {
        value: 'November 10',
        key: 'October10',
    },
    {
        value: 'December 13',
        key: 'December13',
    },
]

export const Trainingtions = [
    {
        value: 'Yes',
        key: 'yes',
    },
    {
        value: 'No',
        key: 'no',
    },
]
export const PROD_DOMAIN = 'hydrafacial.com'

export const HFXDALLAS = [
    {
        value: 'November 14-15',
        key: 'November 14-15',
    },
    {
        value: 'December 1-2',
        key: 'December 1-2',
    },
]

export const HFXTRADALLAS = [
    {
        value: 'October 24-25',
        key: 'October 24-25',
    },
]

export const HFXCHICAGO = [
    {
        value: 'October 20-21',
        key: 'October 20-21',
    },
    {
        value: 'November 14-15',
        key: 'November 14-15',
    },
    {
        value: 'December 5-6',
        key: 'December 5-6',
    },
]

export const HFXTRACHICAGO = [
    {
        value: 'October 17-18',
        key: 'October 17-18',
    },
    {
        value: 'December 12-13',
        key: 'December 12-13',
    },
]

export const HFXLONGBEACH = [
    {
        value: 'October 10-11',
        key: 'October 10-11',
    },
    {
        value: 'November 7-8',
        key: 'November 7-8',
    },
    {
        value: 'December 15-16',
        key: 'December 15-16',
    },
]

export const HFXTRALONGBEACH = [
    {
        value: 'December 1-2',
        key: 'December 1-2',
    },
]

export const HFXNEWYORK = [
    {
        value: 'October 17-18',
        key: 'October 17-18',
    },
    {
        value: 'November 3-4',
        key: 'November 3-4',
    },
    {
        value: 'November 14-15',
        key: 'November 14-15',
    },
    {
        value: 'December 5-6',
        key: 'December 5-6',
    },
]

export const HFXTRANEWYORK = [
    {
        value: 'October 3-4',
        key: 'October 3-4',
    },
    {
        value: 'December 8-9',
        key: 'December 8-9',
    },
]

export const HFXTRAROAD = [
    {
        key: 'November 10 - 11: Miami, FL',
        value: 'November 10 - 11: Miami, FL',
    },
]

export const HFXCenterLocations = [
    { key: 'Choose City', value: 'Choose City' },
    { key: 'Chicago', value: 'Chicago' },
    { key: 'Dallas', value: 'Dallas' },
    { key: 'Long Beach', value: 'Long Beach' },
    { key: 'New York', value: 'New York' },
]

export const HFXTRACenterLocations = [
    { key: 'Choose City', value: 'Choose City' },
    { key: 'Chicago', value: 'Chicago' },
    { key: 'Dallas', value: 'Dallas' },
    { key: 'Long Beach', value: 'Long Beach' },
    { key: 'New York', value: 'New York' },
    { key: 'HFXtra on the road', value: 'HFXtra on the road' },
]

export const HFXClothingSize = [
    {
        key: 'Women XXS',
        value: 'Women XXS',
    },
    {
        key: 'Women XS',
        value: 'Women XS',
    },
    {
        key: 'Women S',
        value: 'Women S',
    },
    {
        key: 'Women M',
        value: 'Women M',
    },
    {
        key: 'Women L',
        value: 'Women L',
    },
    {
        key: 'Women XL',
        value: 'Women XL',
    },
    {
        key: 'Women 2XL',
        value: 'Women 2XL',
    },
    {
        key: 'Men XS',
        value: 'Men XS',
    },
    {
        key: 'Men S',
        value: 'Men S',
    },
    {
        key: 'Men M',
        value: 'Men M',
    },
    {
        key: 'Men L',
        value: 'Men L',
    },
    {
        key: 'Men XL',
        value: 'Men XL',
    },
    {
        key: 'Men 2XL',
        value: 'Men 2XL',
    },
]

export const ContactTime = [
    {
        key: 'Morning (8am to 12pm)',
        value: 'Morning (8am to 12pm)',
    },
    {
        key: 'Afternoon (12pm to 4pm)',
        value: 'Afternoon (12pm to 4pm)',
    },
    {
        key: 'Evening (4pm to 7pm)',
        value: 'Evening (4pm to 7pm)',
    },
]

export const ACCOUNT_SETTINGS_NAMES = [
    {
        name: 'account_settings_page.account_settings_first_text',
        key: 'firstName',
    },
    {
        name: 'account_settings_page.account_settings_last_text',
        key: 'lastName',
    },
    {
        name: 'account_settings_page.account_settings_business_text',
        key: 'businessName',
    },
    {
        name: 'account_settings_page.account_settings_beauty_health_customer_id_text',
        key: 'beautyHealthCustomerId',
    },
    {
        name: 'account_settings_page.account_settings_phone_text',
        key: 'mobilePhoneNumber',
    },
    {
        name: 'account_settings_page.account_settings_country_text',
        key: 'country',
    },
    {
        name: 'account_settings_page.account_settings_date_of_birth_text',
        key: 'dateOfBirth',
    },
    {
        name: 'account_settings_page.account_settings_email_text',
        key: 'emailAddress',
    },
    {
        name: 'account_settings_page.account_settings_account_type_text',
        key: 'userRole',
    },
    {
        name: 'account_settings_page.account_settings_opt_in_text',
        key: 'optInPreferences',
    },
    {
        name: 'account_settings_page.account_settings_sign_in_preferences',
        key: 'signInPreference',
    },
    {
        name: 'account_settings_page.account_settings_delete_account_text',
        key: 'deleteAccount',
    },
]

export const AxiosErrors = {
    ER01: 'NOT_INITIALIZED',
} as const

export const UserRole = {
    Provider: 'Provider',
    Esthetician: 'Hydrafacialist',
    Client: 'Consumer',
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export const PENDING_REQUESTS = [
    { id: 1, email: 'lexid53@gmail.com' },
    { id: 2, email: 'michellez@gmail.com' },
    { id: 3, email: 'bryanb@gmail.com' },
]

export const USER_DATA = [
    { id: 1, email: 'cindy235@gmail.com', update: 'New!' },
    { id: 2, email: 'jackiengo@gmail.com', update: '' },
    { id: 3, email: 'shawnaretier@gmail.com', update: '' },
]

export const CLIENT_REWARDS_NAMES = [
    {
        name: 'client_rewards_tracking.client_rewards_tracking_first_name',
        key: 'firstName',
    },
    {
        name: 'client_rewards_tracking.client_rewards_tracking_email',
        key: 'email',
    },
    {
        name: 'client_rewards_tracking.client_rewards_tracking_phone',
        key: 'mobile',
    },
    {
        name: 'client_rewards_tracking.client_rewards_tracking_reward_points',
        key: 'loyaltyPointBalance',
    },
]

export const ADD_ON_FORM = [
    {
        key: 'booster',
        label: 'client_rewards_tracking.option1_booster_used',
        type: 'checkbox',
        innerForm: true,
        form: [
            {
                key: '1',
                label: '1',
                type: 'radio',
                labelPlacement: 'bottom',
            },
            {
                key: '2',
                label: '2',
                type: 'radio',
                labelPlacement: 'bottom',
            },
            {
                key: '3',
                label: '3',
                type: 'radio',
                labelPlacement: 'bottom',
            },
        ],
    },
    {
        key: 'led_lights',
        label: 'client_rewards_tracking.option2_led_lights',
        type: 'checkbox',
        innerForm: false,
    },
    {
        key: 'therapy',
        label: 'client_rewards_tracking.option3_therapy',
        type: 'checkbox',
        innerForm: false,
    },
]

export const SYNDEO_LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'tc', name: '中文 (繁體)' },
    { code: 'sc', name: '中文 (简体)' },
    { code: 'fr', name: 'Français' },
    { code: 'du', name: 'Deutsch' },
    { code: 'es', name: 'Español' },
    { code: 'pg', name: 'Português' },
    { code: 'kr', name: '한국인' },
    { code: 'jp', name: '日本' },
]

export const PreferenceOptions = {
    NONE: 'account_settings_page.account_settings_opt_in_value_1',
    EMAIL_SMS: 'account_settings_page.account_settings_opt_in_value_2',
    EMAIL: 'account_settings_page.account_settings_opt_in_value_3',
    SMS: 'account_settings_page.account_settings_opt_in_value_4',
} as const

export const signInPreferenceOptions = {
    EMAIL_AND_SMS:
        'account_settings_page.account_settings_send_code_to_sms_and_email',
    INPUT_ONLY:
        'account_settings_page.account_settings_send_code_to_input_only',
    // DEFAULT : "Send Code to SMS and Email"
}

export type signInPreferenceOptions =
    (typeof signInPreferenceOptions)[keyof typeof signInPreferenceOptions]

export type PreferenceOptions =
    (typeof PreferenceOptions)[keyof typeof PreferenceOptions]

export const SYNDEO_SIGNIN_TYPES = [
    { key: 'phone', name: 'sign_in_page.phone_text' },
    { key: 'email', name: 'sign_in_page.email_text' },
]

export const HYDRAFACIAL_OFFICIAL_DOMAIN = 'https://www.hydrafacial.com'

export const SYNDEO_COUNTRY_CODE = [
    'AE',
    'AL',
    'AT',
    'AU',
    'AZ',
    'BA',
    'BB',
    'BE',
    'BG',
    'BH',
    'BR',
    'BS',
    'BY',
    'CA',
    'CH',
    'CL',
    'CO',
    'CR',
    'CY',
    'CZ',
    'DE',
    'DK',
    'DO',
    'DZ',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GE',
    'GR',
    'GT',
    'HK',
    'HN',
    'HR',
    'HU',
    'ID',
    'IE',
    'IL',
    'IN',
    'IS',
    'IT',
    'JP',
    'KG',
    'KR',
    'KW',
    'KY',
    'LI',
    'LT',
    'LU',
    'LV',
    'MA',
    'MC',
    'MD',
    'ME',
    'MT',
    'MX',
    'MY',
    'NI',
    'NL',
    'NO',
    'NZ',
    'OM',
    'OM',
    'PA',
    'PE',
    'PH',
    'PK',
    'PL',
    'PR',
    'PT',
    'QA',
    'RO',
    'RS',
    'RU',
    'SA',
    'SE',
    'SG',
    'SI',
    'SK',
    'SV',
    'TH',
    'TJ',
    'TM',
    'TR',
    'TT',
    'TW',
    'UA',
    'US',
    'UZ',
    'VN',
    'ZA',
]

export const SearchParamKeys = {
    HASH: 'hash',
    KEY: 'key',
    ESTI_KEY: 'esti-key',
    EMAIL: 'email',
} as const

export const ContactUsNo = '1-800-603-4996'
export const ContactEmail = 'orders@hydrafacial.com'

export const SYNDEO_BOOSTER_DURATION_DETAILS = {
    'booster-weekly': 7,
    'booster-monthly': 30,
    'booster-quarterly': 90,
} as const

export type SYNDEO_BOOSTER_DURATION_DETAILS =
    keyof typeof SYNDEO_BOOSTER_DURATION_DETAILS

export const SYNDEO_REPORT_DURATION = [
    { title: 'Last 7 Days', value: 'booster-weekly' },
    { title: 'Last 30 Days', value: 'booster-monthly' },
    { title: 'Last 90 Days', value: 'booster-quarterly' },
]

export const SYNDEO_REPORTS = [
    { title: 'Platinum Treatments', value: '3' },
    { title: 'Delux Treatments', value: '13' },
    { title: 'Signature Treatments', value: '24' },
    { title: 'Avg. Treatment Time', value: '35' },
    { title: 'Boosters', value: '10' },
    { title: 'Keravive', value: '3' },
]

export const ASIAN_LANGUAGES = ['jp', 'sc', 'tc', 'kr']

export const SYNDEO_EXTERNAL_LINKS = [
    ROUTES.STORE_TAB as string,
    ROUTES.THE_DROP as string,
]

export const SYNDEO_API_ERROR_MESSAGES = [
    'email_or_phone_number_already_in_use',
]

export const BULLSEYE_GA_EVENT = {
    MANUAL_SEARCH: 'Manual Search',
    SETUP_CONSULTATION: 'Click contact link',
    LEAD_FORM: 'LeadForm',
}

export const EXCLUDE_SMARTBANNER_LIST = [
    '/professional/',
    '/device/',
    '/treatments/',
    '/provider-enhancements/boosters/',
    '/rewards/',
    '/training/',
    '/store/',
    '/talk-with-sales/',
]

export const NAVIGATION_TYPE_CUSTOMER_GROUP = [
    `/post/:url`,
    `/${BOOSTER_TYPE.SOLUTIONS}/:url`,
    `/${BOOSTER_TYPE.BRANDS}/:url`,
    `/${BOOSTER_TYPE.ENHANCEMENTS}/:url`,
    `/${BOOSTER_TYPE.CARE}/:url`,
    ROUTES.HOME,
    ROUTES.SUPPLIER,
    ROUTES.TERMS,
    ROUTES.SKIN_CONDITIONS,
    ROUTES.EMAIL_SUBMISSION,
    ROUTES.EVENTS,
    ROUTES.EXPLORE_HYDRAFACIAL,
    ROUTES.FIND_HYDRAFACIALIST,
    ROUTES.FRESH_ACCESS,
    ROUTES.HFX,
    ROUTES.HFXCLUSIVE,
    ROUTES.HKX,
    ROUTES.HOW_IT_WORKS,
    ROUTES.JLO_CLIENT_HOME,
    ROUTES.KERAVIVE_B2C,
    ROUTES.LOYALTY_LANDING,
    ROUTES.SCHOOL,
    ROUTES.SEARCH,
    ROUTES.TREATMENT_TYPES,
    ROUTES.TREATMENT_TYPE_DETAIL,
    ROUTES.TREATMENT_TYPE_DETAIL + '/face/',
    ROUTES.TREATMENT_TYPE_DETAIL + '/body/',
    ROUTES.TREATMENT_TYPE_DETAIL + '/lipAndEye/',
    ROUTES.TREATMENT_TYPE_DETAIL + '/scalp/',
    ROUTES.TREATMENT_TYPE_DETAIL + '/express/',
    ROUTES.HYDRALOCK_HA_BOOSTER,
    ROUTES.HYDRAFACIAL_IN_THE_NEWS,
    ROUTES.HYDRAFILLIC,
]

export const NAVIGATION_TYPE_PROVIDER_GROUP = [
    ROUTES.CUSTOMER_PROVIDER,
    ROUTES.DEVICES,
    ROUTES.JLOPROVIDERHOME,
    ROUTES.KERAVIVE_B2B,
    ROUTES.FOR_PROFESSIONAL,
    ROUTES.PROFESSIONAL_TESTIMONIALS,
    ROUTES.PROFESSIONAL_TESTIMONIALS_SUCCESS,
    ROUTES.REWARDS,
    ROUTES.STORE,
    ROUTES.TALK_WITH_SALES,
    ROUTES.TRAINING,
    ROUTES.TREATMENTS,
]

export const USER_AUTHENTICATION_TYPE = {
    SIGNIN: 'sign-in',
    SIGNUP: 'sign-up',
    MULTI_ACCOUNT_SIGN_UP: 'sign-up-mlp',
}

export const PROVIDER_CATEGORIES = [
    {
        name: 'Black Diamond',
        id: '109686',
        icon: 'https://images.contentstack.io/v3/assets/blt504d36ed00347088/blt93ca45207abb5f8d/638468d632130110b279cf02/black_diamond.svg',
    },
    {
        name: 'Master Certified',
        id: '109687',
        icon: 'https://images.contentstack.io/v3/assets/blt504d36ed00347088/blt3b2b8b532f1e3fa6/638468d6f3cbfa105cf512d1/master_certified.svg',
    },
    {
        name: 'Syndeo',
        id: '109688',
        icon: 'https://images.contentstack.io/v3/assets/blt504d36ed00347088/bltf251a7e8f35a31fd/638468d65bd399105c6fcff9/syndeo.svg',
    },
    {
        name: 'Keravive',
        id: '109689',
        icon: 'https://images.contentstack.io/v3/assets/blt504d36ed00347088/bltf1b302927f3ae755/638468d623cd3b1045c359bc/keravive.svg',
    },
]
